import { useState, MouseEvent } from "react";
import { Link } from "react-router-dom";
import { Button, IconButton, SvgIcon, Menu } from "@mui/material";

import "./style.scss";
import { ReactComponent as MenuIcon } from "../../assets/menu.icon.svg";
import { ReactComponent as CrossIcon } from "../../assets/crossIcon.svg";
import { Env } from "../../common/enums/env.enum";
import { FirebaseAuthContainer } from "../../common/containers/auth/firebase-auth-container.util";
import { ThemeContainer } from "../../common/containers/theme/theme.container";
import { isMobileDevice } from "../../common/utilities/platform/platform.util";
import { getHederLogoImg } from "../../common/utilities/logo/logo.util";
import { getEnvName } from "../../common/utilities/env/env.util";
import { SelectionFilterT } from "../menu-filter/menu-filter.comp";

const Header = () => {
    const { user, version, knowledgeBases, logout } = FirebaseAuthContainer.useContainer();
    const { isLightTheme, headerLogo, devMode, devEnv, changeDevEnv, setLeftMenuShown } =
        ThemeContainer.useContainer();
    const [menuAnchor, setMenuAnchor] = useState<Element | null>(null);
    const menuOpen = Boolean(menuAnchor);

    const handleLeftMenuClick = () => {
        setLeftMenuShown(true);
    };

    const handleProfileMenuClick = (event: MouseEvent<HTMLElement>) => {
        setMenuAnchor(event.currentTarget);
    };

    const handleProfileMenuClose = () => {
        setMenuAnchor(null);
    };

    const handleSignOut = () => {
        handleProfileMenuClose();
        logout();
    };

    return (
        <div className="header">
            <IconButton className="header-left-menu" onClick={handleLeftMenuClick}>
                <SvgIcon component={MenuIcon} inheritViewBox />
            </IconButton>
            <Link className="header-logo" to="/">
                <img src={getHederLogoImg(headerLogo, !isLightTheme)} alt="" />
            </Link>
            {user && (
                <div
                    className={`header-profile${isMobileDevice() ? " header-profile__mobile" : ""}`}
                >
                    <div className="header-profile-avatar" onClick={handleProfileMenuClick}>
                        {user.avatar ? (
                            <img
                                src={user.avatar}
                                alt=""
                                referrerPolicy="no-referrer"
                                className="header-profile-avatar_img"
                            ></img>
                        ) : (
                            <div className="header-profile-avatar_label">
                                {user.firstName?.toUpperCase().at(0) ??
                                    user.email.toUpperCase().at(0)}
                            </div>
                        )}
                    </div>
                    <Menu
                        id="basic-menu"
                        anchorEl={menuAnchor}
                        open={menuOpen}
                        onClose={handleProfileMenuClose}
                        MenuListProps={{
                            "aria-labelledby": "basic-button"
                        }}
                        slotProps={{
                            paper: {
                                elevation: 0,
                                className: "profile-menu"
                            }
                        }}
                        transformOrigin={{ horizontal: "right", vertical: "top" }}
                        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    >
                        <div className="profile-menu-content">
                            <IconButton
                                className="profile-menu-button-close"
                                onClick={handleProfileMenuClose}
                            >
                                <CrossIcon />
                            </IconButton>
                            <div className="profile-menu-email">{user.email}</div>
                            <div className="profile-menu-actions">
                                {devMode && devEnv && (
                                    <div className="profile-menu-actions__selection">
                                        <SelectionFilterT
                                            list={Object.values(Env).map(env => ({
                                                label: getEnvName(env),
                                                value: env
                                            }))}
                                            selectedItem={{
                                                label: getEnvName(devEnv),
                                                value: devEnv
                                            }}
                                            setSelectedItem={env => changeDevEnv(env.value as Env)}
                                            rightPosition={true}
                                            minWidth={145}
                                        />
                                    </div>
                                )}
                                <Button
                                    className="profile-menu-actions__button--logout primary-button"
                                    variant="outlined"
                                    onClick={handleSignOut}
                                >
                                    Sign Out
                                </Button>
                            </div>
                            {version && (
                                <div className="profile-menu-version">version: {version}</div>
                            )}
                            {knowledgeBases.length && (
                                <div className="profile-menu-knowledgebase">
                                    ID: {knowledgeBases[0].uid}
                                </div>
                            )}
                        </div>
                    </Menu>
                </div>
            )}
        </div>
    );
};

export default Header;
